import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    ErrorOutline,
    CheckCircleOutline,
    AccountBalanceWallet,
    PhoneInTalk,
    HomeRepairService,
    ArrowRightAlt,
    EventNote,
    InfoOutlined
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    ルームシェア退去時のトラブル、なぜ起こる？
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-cases')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    よくある退去トラブル事例
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('repair-points')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    原状回復で押さえるべきポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('shikikin-negotiation')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    敷金返還交渉のコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('contact-method')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    退去連絡の正しい手順
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888',
                                    fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.97rem' }}>
                                    まとめ・安心して退去を迎えるために
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェア退去時のトラブル、なぜ起こる？
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、<b>ルームシェア</b>は多様なライフスタイルを実現できる住まい方として人気を集めています。一方で、退去の際には「予想外のトラブル」に直面するケースも少なくありません。<br />
                    <Chip label="原状回復" color="primary" variant="outlined" sx={{ mr: 1, mb: 0.5 }} />
                    <Chip label="敷金返還" color="primary" variant="outlined" sx={{ mr: 1, mb: 0.5 }} />
                    <Chip label="退去連絡" color="primary" variant="outlined" sx={{ mb: 0.5 }} />
                    <br />
                    これらは退去時の代表的なキーワードですが、どれも<strong>知識不足やコミュニケーション不足</strong>が原因でトラブルへと発展しやすいものです。本記事では、実際の事例を交えながら、<b>失敗しない退去</b>のための実践的なポイントを徹底解説します。
                </Typography>
                <Box sx={{ my: 3 }}>
                    
                    <Typography variant="caption" display="block" sx={{ textAlign: 'center', mt: 1, color: '#777' }}>
                        ルームメイトとの日常は楽しいものですが、退去時は「お金」や「責任」で揉めることも
                    </Typography>
                </Box>
            </Box>

            {/* よくある退去トラブル事例 */}
            <Box id="trouble-cases" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    よくある退去トラブル事例
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    実際に多く見られるのが、<b>原状回復費用や敷金返還</b>を巡るトラブルです。<br />
                    ここでは、特にルームシェアで発生しやすい事例をピックアップし、その背景とともに解説します。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ErrorOutline color="error" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.03rem' }}>
                                    1. 原状回復費用の負担を巡る対立
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                <b>「壁紙や床の傷は誰の責任？」</b> <br />
                                共有スペースの傷や汚れの修繕費用を、誰がどこまで負担するかが曖昧なまま退去を迎え、揉めてしまうパターン。<br />
                                <span style={{ color: '#999' }}>（例）長期間住んだAさんが先に退去し、細かい傷の負担割合で他のルームメイトと意見が対立。</span>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <AccountBalanceWallet color="warning" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.03rem' }}>
                                    2. 敷金が返ってこない・思ったより少ない
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                <b>「思ったより戻ってこない…」</b><br />
                                管理会社や大家さんが、故意・過失の区別なく修繕費を差し引き、敷金返還で納得できないケース。<br />
                                <span style={{ color: '#999' }}>（例）共用部の汚れで全員分の敷金から多額が引かれた。</span>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <PhoneInTalk color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.03rem' }}>
                                    3. 退去連絡のタイミング・方法で混乱
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                <b>「誰が・いつ・どうやって伝える？」</b><br />
                                退去連絡を怠ったり、口頭のみで済ませてトラブルになるパターン。<br />
                                <span style={{ color: '#999' }}>（例）LINEで伝えたつもりが管理会社に伝わっておらず、家賃が余計に発生。</span>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <HomeRepairService color="secondary" sx={{ mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.03rem' }}>
                                    4. 家具・家電の所有権争い
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                <b>「この冷蔵庫、誰のもの？」</b><br />
                                共有で買った家具・家電を、退去者が持ち出そうとして揉める例。<br />
                                <span style={{ color: '#999' }}>（例）口約束で決めていたため、後で証拠がなくトラブルへ。</span>
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2, mb: 3 }}>
                    <img
                        src="/images/blog/room-inspection_roomshare-taikyo-trouble-case-and-solution.jpg"
                        alt="退去時の立ち会いで管理会社スタッフと入居者が室内の壁や床のチェックを行っているシーン。明るい室内で、手元のメモやチェックリストを確認しながら、原状回復の範囲を丁寧に話し合っている様子。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }}
                    />
                    <Typography variant="caption" display="block" sx={{ textAlign: 'center', mt: 1, color: '#777' }}>
                        退去時の「立ち会い」で細かな確認を怠ると、後で思わぬ請求につながることも
                    </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                    こうしたトラブルは、<b>事前の確認・ルール作り・証拠の保存</b>で大幅に減らせます。次章から具体的な対策を見ていきましょう。
                </Typography>
            </Box>

            {/* 原状回復のポイント */}
            <Box id="repair-points" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    原状回復で押さえるべきポイント
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    退去時の最大の論点は<strong>「どこまで直せばOKか」</strong>という点です。国土交通省のガイドラインや判例も参考に、ルームシェアならではの注意点をまとめました。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary="① 通常損耗・経年劣化は原則「借主負担なし」"
                            secondary="家具の跡や日焼け、軽微な傷は貸主側が負担するのが一般的です。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary="② 共有スペースの責任範囲を明確に"
                            secondary="共用部の傷・汚れは、居住期間や使用頻度に応じて按分するのが理想。入居時に写真で記録を残しましょう。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary="③ 故意・過失の損傷は負担対象"
                            secondary="タバコの焦げ跡やペットによる損傷、落書きなどは該当者または全員で負担。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="success" />
                        </ListItemIcon>
                        <ListItemText
                            primary="④ 立ち会い時は証拠写真を必ず残す"
                            secondary="スマホでOK。証拠があれば不当な請求を防げます。"
                        />
                    </ListItem>
                </List>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <img
                        src="/images/blog/cleaning-check_roomshare-taikyo-trouble-case-and-solution.jpg"
                        alt="退去前に入居者が共有スペースの清掃チェックリストを確認しながら、キッチンやリビングの隅々まで掃除している様子。明るい照明のもと、清潔感ある空間で丁寧に作業している場面。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }}
                    />
                    <Typography variant="caption" display="block" sx={{ textAlign: 'center', mt: 1, color: '#777' }}>
                        退去前の「清掃チェック」と記録写真が、不要な費用負担の抑止力になります
                    </Typography>
                </Box>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#f9fbe7', borderLeft: '4px solid #aed581', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <InfoOutlined color="success" sx={{ mr: 1 }} />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            専門的チェック！
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ pl: 4, pt: 0.5 }}>
                        退去時に「入居時の写真や書類がない」と不利になります。<b>入居直後と退去直前、必ず写真で記録</b>しましょう。<br />
                        共有スペースは、<b>誰が・どの範囲を掃除するか</b>を事前にシェアメイト間で相談・分担しておくと安心です。
                    </Typography>
                </Paper>
            </Box>

            {/* 敷金返還交渉術 */}
            <Box id="shikikin-negotiation" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    敷金返還交渉のコツ
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    <b>敷金</b>は「預けたお金」ですが、<b>返ってこない理由が曖昧</b>という声は多いです。適切な返還を受けるための交渉ポイントを押さえましょう。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <AccountBalanceWallet color="primary" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    ポイント1：請求明細は必ずもらう
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                <b>「何にいくら使ったか？」</b>を明細で確認。不明瞭なら質問しましょう。<br />
                                <span style={{ color: '#999' }}>「一式で○万円」など曖昧な請求はNGです。</span>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <EventNote color="action" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    ポイント2：交渉は「記録」に残す
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                メールや書面でやりとりを行いましょう。電話や口頭だけでは証拠が残らず、不利になりがちです。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ArrowRightAlt color="success" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    ポイント3：国のガイドラインを活用
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                国土交通省「原状回復をめぐるトラブルとガイドライン」を提示すると、理不尽な請求への抑止力に。<br />
                                <Link href="https://www.mlit.go.jp/jutakukentiku/house/torikumi/hendo.html" target="_blank" rel="noopener">
                                    公式サイトを見る
                                </Link>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <CheckCircleOutline color="info" sx={{ mr: 1 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                    ポイント4：納得できない場合は相談を
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                消費生活センターや、各地の宅建協会・弁護士への無料相談も活用を。感情的にならず、冷静に交渉しましょう。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#e3f2fd', borderLeft: '4px solid #42a5f5', mt: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        <InfoOutlined fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
                        <b>ルームシェア特有の注意点</b>
                    </Typography>
                    <Typography variant="body2" sx={{ pl: 3, pt: 0.5 }}>
                        複数人で敷金を預けていた場合、「代表者」だけでなく全員の意思を確認しましょう。<br />
                        退去者・残留者・大家の三者間で認識を揃えることが、後々のトラブル防止になります。
                    </Typography>
                </Paper>
            </Box>

            {/* 退去連絡の正しい手順 */}
            <Box id="contact-method" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    退去連絡の正しい手順
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    退去時は<strong>「いつ」「誰に」「どのように」</strong>連絡するかがポイントです。曖昧な伝達は後々の請求やトラブルの元になります。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="1. 退去の意思を決めたら、まずルームメイトに報告"
                            secondary="共有スペースの使い方や費用分担が変わるため、早めの相談が吉。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="2. 管理会社・大家へは文書またはメールで通知"
                            secondary="口頭やSNSだけでは証拠が残らないため、必ず記録が残る方法で。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="3. 退去日・立ち会い日を確定し、書面で確認"
                            secondary="家賃発生日や清算トラブルを避けるため、日時は明文化を。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary="4. ルームメイト間でも決定事項を共有"
                            secondary="LINEグループなどでも構いませんが、分担や費用精算は後で揉めないように記録を残しましょう。"
                        />
                    </ListItem>
                </List>
                <Paper elevation={0} sx={{ p: 2, bgcolor: '#fff8e1', borderLeft: '4px solid #ffd54f', mt: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        <PhoneInTalk fontSize="small" sx={{ mr: 1, verticalAlign: 'middle', color: '#ffb300' }} />
                        <b>よくある失敗例</b>
                    </Typography>
                    <Typography variant="body2" sx={{ pl: 3, pt: 0.5 }}>
                        退去連絡を「口頭だけ」で済ませてしまい、<b>家賃や光熱費の精算で揉める</b>ケースが目立ちます。<br />
                        必ず<b>書面やメール</b>で、「誰が・いつ・何を伝えたか」を明確に残しましょう。
                    </Typography>
                </Paper>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ・安心して退去を迎えるために
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアの退去時トラブルは、「知らなかった」「伝わっていなかった」が最大の原因です。
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleOutline color="success" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="入居時・退去時の写真記録を徹底"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleOutline color="success" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="ルール・分担・精算方法を明文化"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleOutline color="success" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="書面やメールで連絡＆記録を残す"
                                />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img
                            src="/images/blog/roommate-agreement_roomshare-taikyo-trouble-case-and-solution.jpg"
                            alt="ルームメイト同士がテーブルで契約書やルールブックにサインしている様子。若い男女数名が真剣な表情で書類を見つめ、安心感と信頼感が感じられる室内。"
                            style={{ width: '100%', maxWidth: 260, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }}
                        />
                    </Grid>
                </Grid>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    「気まずくなりたくない」「面倒だから…」と曖昧にせず、<b>ルール・証拠・記録</b>を意識することで、不安やトラブルは大きく減らせます。<br />
                    ルームシェアは退去までが“チームプレー”。安心して新生活へ踏み出せるよう、ぜひ本記事のポイントを実践してみてください。
                </Typography>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-taikyo-trouble-case-and-solution',
    slug: 'roomshare-taikyo-trouble-case-and-solution',
    title: 'ルームシェアの「退去トラブル」事例と回避策',
    excerpt: '退去時のよくあるトラブル 原状回復のポイント 敷金返還交渉術 退去時の連絡方法',
    coverImage: '/images/blog/cover-roomshare-trouble_roomshare-taikyo-trouble-case-and-solution.jpg',
    coverImageAlt: '明るい自然光に包まれたモダンなルームシェアの共有リビングで、複数のルームメイトが退去に関する話し合いを穏やかに進めている様子。木製のダイニングテーブルやカラフルなインテリア、小物が配置され、信頼感と安心感が感じられる雰囲気。',
    publishedAt: '2024-06-12T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '賃貸トラブル', '退去ガイド'],
    tags: ['原状回復', '敷金交渉', '退去連絡', 'シェアハウス', '住まいの知識'],
    author: {
        name: '佐藤 雅人',
        avatar: '/images/avatars/satou-masato.jpg',
        bio: '賃貸住宅管理・シェアハウス運営分野で10年以上の実務経験を持つ、ルームシェアと住まいのトラブル解決を専門に活動するアドバイザー。複数のメディアでコラム執筆も行い、現場目線のリアルなアドバイスに定評あり。',
        profilePicture: '/images/avatars/satou-masato.jpg'
    },
    viewCount: 1000,
    contentComponent: PostContent
};

export default post;